import React, { useState } from 'react'
import { connect } from 'react-redux'
import { clearReservationAction, setUIForwardAction } from '../../actions'
import { UI } from '../../constants/ui'
import DevTools from '../DevTool'
import './footer-mobile.less'
import logo from '../../assets/logo.png'
import { AppState } from '../../reducers'
import { useTranslation } from 'react-i18next'
import SelectorLanguageFooterMobile from '../SelectorLanguageFooterMobile'

interface FooterMobileProps {
  showPageCount?: boolean
  back?: () => void
}

const mapStateToProps = (state: AppState) => ({
  totalPagesCount: state.reservation.totalPagesCount,
  currentPage: state.reservation.currentPage,
})


interface DispatchProps {
  setUI: (ui: UI) => void
  clearReservation: () => void
}
const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  setUI: (ui: UI): void => dispatch(setUIForwardAction(ui)),
  clearReservation: (): void => dispatch(clearReservationAction()),
})

type StateProps = ReturnType<typeof mapStateToProps>
type Props = StateProps & DispatchProps & FooterMobileProps

const FooterMobile: React.FC<Props> = ({ showPageCount, currentPage, totalPagesCount, back, setUI, clearReservation }) => {
  const { t } = useTranslation()
  const [showDevTools, setShowDevTools] = useState(false)
  const [showSelectorLanguage, setShowSelectorLanguage] = useState(false)

  const toggleDevTools = (value: boolean) => {
    const testMode = window.location.search.includes('test-mode')
    if (testMode) {
      setShowDevTools(value)
    }
  }

  const onExit = () => {
    clearReservation()
    setShowSelectorLanguage(false)
    setUI(UI.LANGUAGE_SELECTION)
  }

  return (<>
    {showSelectorLanguage && <div className="background-pad-mobile" onClick={() => setShowSelectorLanguage(false)}></div>}
    {!!back && (
      <div className="back-button-container-mobile">
        <button className="back-button" onClick={back}>
          <div className="text-button">{'← ' + t('back')}</div>
        </button>
      </div>
    )}
    <div className="footer-mobile">
      <img className="logo" src={logo} alt="logo" onClick={() => toggleDevTools(!showDevTools)} />
      <div className="right-side-elements">
        {!!showPageCount && (
          <div className="pages-counter">
            <div className="bold-label">{currentPage}</div>
            <div className="label">/ {totalPagesCount}</div>
          </div>
        )}
        <div className="burger-container" onClick={() => setShowSelectorLanguage(value => !value)}>
          {!showSelectorLanguage && <>
            <div className="burger-line"></div>
            <div className="burger-line"></div>
            <div className="burger-line"></div>
          </>}
          {showSelectorLanguage && <>
            <div className="cross-line slash"></div>
            <div className="cross-line backslash"></div>
          </>}
        </div>
      </div>
      {showSelectorLanguage && (
        <div className="language-selector-container">
          <SelectorLanguageFooterMobile onClose={() => setShowSelectorLanguage(false)} onExit={onExit} />
        </div>
      )}
      {showDevTools && <DevTools onClose={() => toggleDevTools(false)} />}
    </div>
  </>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterMobile)
